import { useAuthStore } from "../../../AuthStore/useAuthStore";
import { api } from "../../api";

export const ACCESS_TOKEN_REVOKE_PATH = "/api/access_tokens/revoke";

/**
 * Ends the current session server-side: the API revokes the bearer it authenticated with (plus its
 * refresh token) at the auth server and stops accepting it right away, instead of when the token
 * expires. Best effort by design: the local logout proceeds no matter what happens here, and a
 * failure only means the token dies at expiry rather than now.
 *
 * Must run before the auth store is reset, since it authenticates with the token being revoked.
 */
export async function revokeAccessToken(): Promise<void> {
  if (!useAuthStore().token.value) {
    return;
  }

  try {
    await api.post(ACCESS_TOKEN_REVOKE_PATH, undefined, { timeout: 5000 });
  } catch (e) {
    console.warn("[Logout] The access token could not be revoked, it stays valid until it expires.", e);
  }
}
